var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head-box"},[(_vm.templalteIntro && _vm.templalteIntro.isStepPage)?_c('prosess'):_c('logo',{attrs:{"isCenter":_vm.isCenter,"bgColor":_vm.bgColor,"templalteIntro":_vm.templalteIntro,"isHideTitle":_vm.isHideTitle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }